import { Field } from 'formik'
import React from 'react'

import { Fieldset, Input } from '@fourthwall/components'

export const HeaderForm = () => {
  return (
    <Fieldset.Row>
      <Fieldset.Item>
        <Field name="content" component={Input} label="Content" placeholder="Header content" />
      </Fieldset.Item>
    </Fieldset.Row>
  )
}
